/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import ic_check_circle from "../../assets/images/pictures/icon/ic_check-circle_24px.svg";
import ic_person_check from "../../assets/images/pictures/icon/ic_person_24px.svg";
import ic_clock from "../../assets/images/pictures/icon/ic_clocks.svg";
import ic_check_list from "../../assets/images/pictures/icon/ic_check-list_24px.svg";
import ic_file from "../../assets/images/pictures/icon/ic_file_24px.svg";
import ic_sim from "../../assets/images/pictures/icon/ic_sim.svg";
import ic_book from "../../assets/images/pictures/icon/ic_book_24px.svg";
import ic_earth from "../../assets/images/pictures/icon/ic_earth_24px.svg";
import ic_search from "../../assets/images/pictures/icon/ic_search_24px.svg";
import ic_comment from "../../assets/images/pictures/icon/ic_comments_24px.svg";
import ic_list from "../../assets/images/pictures/icon/ic_list_24px.svg";
import ic_share from "../../assets/images/pictures/icon/ic_share_24px.svg";
import ic_bell from "../../assets/images/pictures/icon/ic_bell_24px.svg";
import ic_audit from "../../assets/images/pictures/icon/ic_audit_24px.svg";
import ic_location from "../../assets/images/pictures/icon/ic_location_24px.svg";
import google_play_en from "../../assets/images/logos/android-ios/google-play-en.png";
import google_play_vi from "../../assets/images/logos/android-ios/google-play-vi.png";
import app_store_en from "../../assets/images/logos/android-ios/app-store-en.png";
import app_store_vi from "../../assets/images/logos/android-ios/app-store-vi.svg";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import NavbarBottom from "./../global/NavbarBottom";
import Footer from "./../global/Footer";
import feature_content_4 from "../../assets/images/pictures/Signed.png";

const FeaturesContent = () => {
  const { t, i18n } = useTranslation();

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
    >
      <div className="container-fuild bg-color-home background-features-image">
        <div className="container">
          <div className="row">
            {/* <div className="col-md-7 col-md-push-5">
                            <p>AAA</p>
                        </div> */}
            <div className="col-md-9 px-md-0 pt-116">
              <h2 className="font-weight-bold mx-auto text-white font-60">
                {t("features-page.features-content.content-1.heading")}
              </h2>
              <p className="mb-25 mt-25 text-white max-width-lg-70-percent">
                {t("features-page.features-content.content-1.description")}
              </p>
              <a
                href={`https://gopaperless.mobile-id.vn/workflow/portal/login?language=${
                  i18n.language || "vi"
                }`}
                rel="noreferrer"
                target="_blank"
                id="button-start-free-en"
                className="btn-secondary"
              >
                {t("features-page.features-content.content-1.button-signing")}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="features-page bg-color-features">
        <div className="container features-page__container pt-50">
          <div className="row text-center">
            <div className="col-sm-12 pb-50">
              <img
                width="64"
                height="64"
                src={ic_location}
                className="attachment-full size-full"
                alt="ic_location"
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <h2 className="heading font-weight-bold mx-auto pt-16">
                {t("features-page.features-content.content-3.big-heading")}
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 px-md-0">
              <div className="text-center boxes justify-between">
                <div className="boxes__item boxes__item--min-h">
                  <div className="blue-circle-outline">
                    <div className="bluecirlce-inline">
                      <img
                        width="24"
                        height="24"
                        src={ic_file}
                        className="attachment-full size-full"
                        alt="ic_file"
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                    </div>
                  </div>

                  <p className="my-18-12 font-weight-bold">
                    {t(
                      "features-page.features-content.content-3.small-heading-1"
                    )}
                  </p>
                  <p>
                    {t(
                      "features-page.features-content.content-3.small-description-1"
                    )}
                  </p>
                </div>
                <div className="boxes__item boxes__item--min-h">
                  <div className="blue-circle-outline">
                    <div className="bluecirlce-inline">
                      <img
                        width="24"
                        height="24"
                        src={ic_sim}
                        className="attachment-full size-full"
                        alt="ic_sim"
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                    </div>
                  </div>

                  <p className="font-weight-bold my-18-12">
                    {t(
                      "features-page.features-content.content-3.small-heading-2"
                    )}
                  </p>
                  <p>
                    {t(
                      "features-page.features-content.content-3.small-description-2"
                    )}
                    &nbsp;
                    <a href="/eids">
                      {t(
                        "features-page.features-content.content-3.small-description-2-1"
                      )}
                    </a>
                  </p>
                </div>
                <div className="boxes__item boxes__item--min-h">
                  <div className="blue-circle-outline">
                    <div className="bluecirlce-inline">
                      <img
                        width="24"
                        height="24"
                        src={ic_clock}
                        className="attachment-full size-full"
                        alt="ic_clock"
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                    </div>
                  </div>

                  <p className="font-weight-bold my-18-12">
                    {t(
                      "features-page.features-content.content-3.small-heading-3"
                    )}
                  </p>
                  <p>
                    {t(
                      "features-page.features-content.content-3.small-description-3"
                    )}
                  </p>
                </div>
                <div className="boxes__item boxes__item--min-h">
                  <div className="blue-circle-outline">
                    <div className="bluecirlce-inline">
                      <img
                        width="24"
                        height="24"
                        src={ic_book}
                        className="attachment-full size-full"
                        alt="ic_book"
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                    </div>
                  </div>

                  <p className="font-weight-bold my-18-12">
                    {t(
                      "features-page.features-content.content-3.small-heading-4"
                    )}
                  </p>
                  <p>
                    {t(
                      "features-page.features-content.content-3.small-description-4"
                    )}
                  </p>
                </div>
                <div className="boxes__item boxes__item--min-h">
                  <div className="blue-circle-outline">
                    <div className="bluecirlce-inline">
                      <img
                        width="20"
                        height="20"
                        src={ic_earth}
                        className="attachment-full size-full"
                        alt="ic_earth"
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                    </div>
                  </div>

                  <p className="font-weight-bold my-18-12">
                    {t(
                      "features-page.features-content.content-3.small-heading-5"
                    )}
                  </p>
                  <p>
                    {t(
                      "features-page.features-content.content-3.small-description-5"
                    )}
                  </p>
                </div>
                <div className="boxes__item boxes__item--min-h">
                  <div className="blue-circle-outline">
                    <div className="bluecirlce-inline">
                      <img
                        width="24"
                        height="24"
                        src={ic_search}
                        className="attachment-full size-full"
                        alt="ic_search"
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                    </div>
                  </div>

                  <p className="font-weight-bold my-18-12">
                    {t(
                      "features-page.features-content.content-3.small-heading-6"
                    )}
                  </p>
                  <p>
                    {t(
                      "features-page.features-content.content-3.small-description-6"
                    )}
                  </p>
                </div>
                <div className="boxes__item boxes__item--min-h">
                  <div className="blue-circle-outline">
                    <div className="bluecirlce-inline">
                      <img
                        width="24"
                        height="24"
                        src={ic_comment}
                        className="attachment-full size-full"
                        alt="ic_comment"
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                    </div>
                  </div>

                  <p className="font-weight-bold my-18-12">
                    {t(
                      "features-page.features-content.content-3.small-heading-7"
                    )}
                  </p>
                  <p>
                    {t(
                      "features-page.features-content.content-3.small-description-7"
                    )}
                  </p>
                </div>
                <div className="boxes__item boxes__item--min-h">
                  <div className="blue-circle-outline">
                    <div className="bluecirlce-inline">
                      <img
                        width="24"
                        height="24"
                        src={ic_list}
                        className="attachment-full size-full"
                        alt="ic_list"
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                    </div>
                  </div>

                  <p className="font-weight-bold my-18-12">
                    {t(
                      "features-page.features-content.content-3.small-heading-8"
                    )}
                  </p>
                  <p>
                    {t(
                      "features-page.features-content.content-3.small-description-8"
                    )}
                  </p>
                </div>
                <div className="boxes__item boxes__item--min-h">
                  <div className="blue-circle-outline">
                    <div className="bluecirlce-inline">
                      <img
                        width="24"
                        height="24"
                        src={ic_share}
                        className="attachment-full size-full"
                        alt="ic_share"
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                    </div>
                  </div>

                  <p className="font-weight-bold my-18-12">
                    {t(
                      "features-page.features-content.content-3.small-heading-9"
                    )}
                  </p>
                  <p>
                    {t(
                      "features-page.features-content.content-3.small-description-9"
                    )}
                  </p>
                </div>
                <div className="boxes__item boxes__item--min-h">
                  <div className="blue-circle-outline">
                    <div className="bluecirlce-inline">
                      <img
                        width="24"
                        height="24"
                        src={ic_bell}
                        className="attachment-full size-full"
                        alt="ic_bell"
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                    </div>
                  </div>

                  <p className="font-weight-bold my-18-12">
                    {t(
                      "features-page.features-content.content-3.small-heading-10"
                    )}
                  </p>
                  <p>
                    {t(
                      "features-page.features-content.content-3.small-description-10"
                    )}
                  </p>
                </div>
                <div className="boxes__item boxes__item--min-h">
                  <div className="blue-circle-outline">
                    <div className="bluecirlce-inline">
                      <img
                        width="24"
                        height="24"
                        src={ic_audit}
                        className="attachment-full size-full"
                        alt="ic_audit"
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                    </div>
                  </div>

                  <p className="font-weight-bold my-18-12">
                    {t(
                      "features-page.features-content.content-3.small-heading-11"
                    )}
                  </p>
                  <p>
                    {t(
                      "features-page.features-content.content-3.small-description-11"
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container features-page__container">
          <div className="row">
            <div className="col-md-10 col-md-offset-1 col-sm-12 text-center pb-30">
              <img
                width="64"
                height="64"
                src={ic_check_circle}
                className="img-responsive"
                alt="ic_check_circle"
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <h2 className="font-weight-bold">
                {t("features-page.features-content.content-2.big-heading")}
              </h2>
              <p>
                {t("features-page.features-content.content-2.big-description")}
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 px-md-0">
              <div className="text-center boxes boxes--one-row">
                <div className="boxes__item">
                  <div className="blue-circle-outline">
                    <div className="yellow-circle-inline">
                      <img
                        width="24"
                        height="24"
                        src={ic_person_check}
                        className="attachment-full size-full"
                        alt="ic_person_check"
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                    </div>
                  </div>

                  <h5 className="heading">
                    {t(
                      "features-page.features-content.content-2.small-heading-1"
                    )}
                  </h5>
                  <p>
                    {t(
                      "features-page.features-content.content-2.small-description-1"
                    )}
                  </p>
                </div>
                <div className="boxes__item">
                  <div className="blue-circle-outline">
                    <div className="yellow-circle-inline">
                      <img
                        width="24"
                        height="24"
                        src={ic_clock}
                        className="attachment-full size-full"
                        alt="ic_clock"
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                    </div>
                  </div>

                  <h5 className="heading">
                    {t(
                      "features-page.features-content.content-2.small-heading-2"
                    )}
                  </h5>
                  <p>
                    {t(
                      "features-page.features-content.content-2.small-description-2"
                    )}
                  </p>
                </div>
                <div className="boxes__item">
                  <div className="blue-circle-outline">
                    <div className="yellow-circle-inline">
                      <img
                        width="24"
                        height="24"
                        src={ic_check_list}
                        className="attachment-full size-full"
                        alt="ic_check_list"
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                    </div>
                  </div>

                  <h5 className="heading">
                    {t(
                      "features-page.features-content.content-2.small-heading-3"
                    )}
                  </h5>
                  <p>
                    {t(
                      "features-page.features-content.content-2.small-description-3"
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <img
                src={feature_content_4}
                className="img-responsive"
                alt=""
                decoding="async"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="for-teams">
          <div className="container px-md-0">
            <div className="row">
              <div className="col-sm-7">
                <img
                  width="532"
                  height="489"
                  src={require("../../assets/images/pictures/features-content-2.png")}
                  className="img-responsive"
                  alt="for-teams"
                  decoding="async"
                  loading="lazy"
                />
              </div>
              <div className="col-sm-5 for-teams__content">
                <h2 className="heading font-weight-bold mx-auto ">
                  {t("features-page.features-content.content-4.heading")}
                </h2>
                <p className="mb-25 mt-25">
                  {t("features-page.features-content.content-4.description")}
                </p>
                <a
                  href="/features-for-teams"
                  className="btn-secondary"
                  target=""
                >
                  {t("features-page.features-content.content-4.button-explore")}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="container flex center center--perfect px-md-0 bg-white-radius pr-35 pl-35"
          id="mobile-app-download"
        >
          <div className="col-6">
            <h2 className="heading font-weight-bold no-margin-md">
              {t("features-page.features-content.content-5.heading")}
            </h2>
            <p className="mb-25 mt-25">
              {t("features-page.features-content.content-5.description")}
            </p>

            <div className="buttons-group">
              <a
                href="https://apps.apple.com/vn/app/gopaperless/id6751082534"
                target="_blank"
                rel="noreferrer "
                className="mr-16"
              >
                <img
                  width="150"
                  height="50"
                  src={i18n.language === "en" ? app_store_en : app_store_vi}
                  className="attachment-full size-full"
                  alt="app-store"
                  decoding="async"
                  loading="lazy"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=vn.mobileid.gopaperless.client&pcampaignid=web_share"
                target="_blank"
                rel="noreferrer "
              >
                <img
                  width="168"
                  height="50"
                  src={i18n.language === "en" ? google_play_en : google_play_vi}
                  className="attachment-full size-full"
                  alt="google-play"
                  decoding="async"
                  loading="lazy"
                />
              </a>
            </div>
          </div>
          <div className="col-6">
            <img
              width="555"
              src={require("../../assets/images/pictures/features-content-3.png")}
              className="img-responsive height-400"
              alt="overview-features"
              decoding="async"
              loading="lazy"
            />
          </div>
        </div>
        <div className="height-50"></div>
      </div>

      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default FeaturesContent;
